import {
  useSelectedCompany,
  getAccessTokenPayloadSync,
} from "@flash-tecnologia/hros-web-utility";

interface SelectedCompany {
  id: string;
  name: string;
  registrationNumber: string;
}

export const useSession = () => {
  const { selectedCompany } = useSelectedCompany();
  const session = getAccessTokenPayloadSync();
  const company = selectedCompany as SelectedCompany;
  return {
    userId: session?.employeeId,
    economicGroupId: session?.economicGroupId,
    companyId: company.id,
  };
};
